import { render, staticRenderFns } from "./AppSynthesisObservation.vue?vue&type=template&id=37ebaff9&"
import script from "./AppSynthesisObservation.vue?vue&type=script&lang=js&"
export * from "./AppSynthesisObservation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports